import type { SeparationState } from '@integrate/core';
import { phaseChip, visiblePhases, type PhaseId } from './phases.js';

/**
 * The workflow stepper, ported from `renderPhaseBar` (orgchart.html:5866).
 *
 * Collapsed until there are people, because every chip below it is a statement about a population and
 * "0 people · clean" is a worse answer than saying nothing yet.
 */
export function PhaseBar({
  state,
  phase,
  onSelect,
}: {
  state: SeparationState;
  phase: PhaseId;
  onSelect(id: PhaseId): void;
}): JSX.Element | null {
  if (!state.employees.length) return null;

  return (
    <div className="phase-bar" data-testid="phase-bar" role="tablist" aria-label="Workflow phase">
      {visiblePhases(state).map((p, i) => (
        <span key={p.id} style={{ display: 'contents' }}>
          {i > 0 && <span className="phase-sep">›</span>}
          <button
            className={`phase-step ${phase === p.id ? 'active' : ''}`}
            data-testid={`phase-${p.id}`}
            role="tab"
            aria-selected={phase === p.id}
            title={p.title}
            onClick={() => onSelect(p.id)}
          >
            <span className="phase-num">{i + 1}</span>
            {p.label}
            <span className="phase-chip">{phaseChip(state, p.id)}</span>
          </button>
        </span>
      ))}
    </div>
  );
}
